import { PAYMENT_METHOD_HASH_TYPE_TOKENEX } from '../../constants';

export const tokenexPaymentMethodHashPayloadFactory = (paymentData: any) => {
  const [expMonth, expYear] = paymentData.cardExpire.split('/');
  const cardholderName = paymentData.cardholderName || `${paymentData.firstName} ${paymentData.lastName}`.trim();
  return {
    type: 'card',
    card: {
      type: PAYMENT_METHOD_HASH_TYPE_TOKENEX,
      [PAYMENT_METHOD_HASH_TYPE_TOKENEX]: {
        token: paymentData.cardNumber.token,
        cvvToken: paymentData.cvv.token,
        cardholderName,
        expMonth,
        expYear: `20${expYear}`, // Millenials of the next century - be prepared! :)
      },
    },
    billing_details: {
      name: cardholderName || '',
      email: paymentData.billingEmail || '',
      address1: paymentData.billingAddress1 || '',
      address2: paymentData.billingAddress2 || '',
      city: paymentData.billingCity || '',
      state: paymentData.billingState || '',
      zip: paymentData.billingZip || '',
      country: paymentData.billingCountry || '',
      // TODO: document is BE tech debt, but we support it as well as "real" document related fields
      document: paymentData.billingDocumentNumber || '',
      documentNumber: paymentData.billingDocumentNumber || '',
      documentType: paymentData.billingDocumentType || '',
    },
  };
};
